import CookieInfo from "./_components/cookie-info";

export default CookieInfo;
